import {$} from '../utils';

function mobileMenu() {
    const openBtn = document.getElementById('menu-open');
    const closeBtn = document.getElementById('menu-close');
    const menu = document.getElementById('mobile-menu');
    const htmElement = document.querySelector('html');

    if (openBtn) {
        // Adding click event
        openBtn.addEventListener('click', () => {
            menu.classList.add("active");
            htmElement.classList.add('bodyLock');
        });
    }
    
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            menu.classList.remove("active");
            htmElement.classList.remove('bodyLock');
        });
    }

    // Adding active class to main menu
    const links = document.querySelectorAll('.mainNav a');
    $(links, function (link) {
        if (!links || !links.length) return;
        const path = link.getAttribute('href');
        const location = window.location.href.toString() || '';
        if (location.includes(path)) {
            link.classList.add('active');
        }
    });

    const Flinks = document.querySelectorAll('.ftLinks a');
    $(Flinks, function (link) {
        if (!Flinks || !Flinks.length) return;
        const path = link.getAttribute('href');
        const location = window.location.href.toString() || '';
        if (location.includes(path)) {
            link.classList.add('active');
        }
    });


    const menus = document.querySelectorAll('.dropDownArrow');
    if(menus && menus.length) {
        $(menus, (item) => {
            item.addEventListener('click', () => {
                const dropDown = item.parentNode.parentNode;
                const header = document.querySelector('#header');
                if(dropDown.classList.contains('active')) {
                    dropDown.classList.remove('active');
                    header.classList.remove('dropDownActive');
                } else {
                    const allDropDowns = document.querySelectorAll('.mainNav > ul > li');
                    $(allDropDowns).removeClass('active');
                    header.classList.add('dropDownActive');
                    dropDown.classList.add('active');
                }
            });        
        });
    }
}

export default mobileMenu;